import { useEffect, useState } from 'react';

const useDarkMode = () => {
    const [theme, setTheme] = useState(() =>
        localStorage.getItem('theme') || (window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')
    );

    useEffect(() => {
        document.documentElement.classList.remove('light', 'dark');
        document.documentElement.classList.add(theme);
        localStorage.setItem('theme', theme);
        console.log("🌗 Přepnuto na:", theme);
    }, [theme]);


    const toggleTheme = () => {
        setTheme(prev => (prev === 'dark' ? 'light' : 'dark'));
        console.log("Aktuální theme:", theme);
    };

    return [theme, toggleTheme];
};

export default useDarkMode;
